import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 sm:py-32" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-90">
      <div className="max-w-2xl mx-auto px-5 sm:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="rounded-xl p-10 sm:p-12 text-center backdrop-blur-sm" style={{
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }} data-id="element-92">
          <ShieldCheckIcon className="w-14 h-14 mx-auto mb-6" style={{
          color: '#f97316'
        }} aria-hidden="true" data-id="element-93" />

          <h2 className="text-2xl sm:text-3xl font-black tracking-tight text-white mb-5" data-id="element-94">
            The "Time Saved" Guarantee
          </h2>

          <p className="text-lg leading-relaxed" style={{
          color: '#d4d4d8'
        }} data-id="element-95">
            Use these scripts for 7 days. If you haven't saved at least 5 hours
            of useless meeting time, I'll refund your $6.39. No questions. Keep
            your time.
          </p>
        </motion.div>
      </div>
    </section>;
}